import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, TextField, Button, Typography, Alert } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { getPatient } from "../api/patients";

export default function FindPatientPage() {
  const [searchId, setSearchId] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSearch = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!searchId.trim()) return;
    setError("");
    setLoading(true);
    try {
      await getPatient(searchId.trim().toUpperCase());
      navigate(`/patient/${searchId.trim().toUpperCase()}`);
    } catch (err: any) {
      if (err.response?.status === 404) {
        setError("Пациент не найден");
      } else {
        setError("Ошибка при поиске");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box>
      <Typography variant="h5" sx={{ mb: 3 }}>
        Найти пациента
      </Typography>

      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      <form onSubmit={handleSearch}>
        <TextField
          fullWidth
          label="ID пациента"
          placeholder="Например: 65F123"
          value={searchId}
          onChange={(e) => setSearchId(e.target.value)}
          margin="normal"
          autoFocus
          slotProps={{
            htmlInput: {
              style: { fontSize: 20, fontFamily: "monospace", letterSpacing: 2 },
            },
          }}
        />

        <Button
          type="submit"
          fullWidth
          variant="contained"
          size="large"
          disabled={loading || !searchId.trim()}
          startIcon={<SearchIcon />}
          sx={{ mt: 2 }}
        >
          {loading ? "Поиск..." : "Найти"}
        </Button>
      </form>
    </Box>
  );
}
